import { InfluencerCoupons } from "modules/coupons";

const InfluencerCouponsPage = () => {
  return <InfluencerCoupons />;
};

export default InfluencerCouponsPage;
